import { MobileContainer } from '@/components/workflow/mobile-container';
import { MobileHeader } from '@/components/workflow/mobile-header';
import { Checkbox, Flex, Grid, Text } from '@mantine/core';
import { useBaleInboundContext } from '../hook';

export const BaleInboundLoadConfirmationPage = () => {
	const { setPage, formData, contamination, scannedBales, isConfirmed, setIsConfirmed } =
		useBaleInboundContext();

	const handleBack = () => {
		// Reset confirmation state when going back
		setIsConfirmed(false);
		setPage('EVALUATION');
	};

	return (
		<MobileContainer header={<MobileHeader title="Confirm Load" onBack={handleBack} />}>
			<Flex direction="column" gap="md" pb={100} p="md">
				<Grid>
					<Grid.Col span={6}>
						<Flex
							bg="white"
							w="100%"
							style={{
								borderRadius: 6,
								boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
								border: '1px solid #E0E0E0',
							}}
							direction="column"
							gap="lg"
							p="lg"
							align="center"
							justify="center"
							ta="center"
							pb="xl"
						>
							<Text size="sm" fw={600}>
								Bales
							</Text>
							<Text style={{ fontSize: 62 }} fw={600}>
								{scannedBales.reduce((acc, bale) => acc + bale.count, 0)}
							</Text>
						</Flex>
					</Grid.Col>
					<Grid.Col span={6}>
						<Flex
							bg="white"
							w="100%"
							style={{
								borderRadius: 6,
								boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
								border: '1px solid #E0E0E0',
							}}
							direction="column"
							gap="lg"
							p="lg"
							align="center"
							justify="center"
							ta="center"
							pb="xl"
						>
							<Text size="sm" fw={600}>
								Contamination
							</Text>
							<Text style={{ fontSize: 62, display: 'flex', alignItems: 'flex-start' }} fw={600}>
								{contamination} <span style={{ fontSize: 24, marginLeft: 4 }}>%</span>
							</Text>
						</Flex>
					</Grid.Col>
					<Grid.Col span={12}>
						<Flex
							bg="white"
							w="100%"
							style={{
								borderRadius: 6,
								boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
								border: '1px solid #E0E0E0',
							}}
						>
							<Flex direction="column" gap="xs" w="100%" p="md">
								<Flex justify="space-between" w="100%">
									<Text fw={600}>Load Details</Text>
								</Flex>

								<Grid w="100%">
									<Grid.Col span={6}>
										<Flex direction="column" gap="xs">
											<Flex direction="column">
												<Text m={0} p={0} c="grey" size="xs">
													Docket ID
												</Text>
												<p
													style={{
														fontFamily: 'monospace',
														fontSize: 16,
														fontWeight: 600,
														margin: 0,
													}}
												>
													{formData.docketId}
												</p>
											</Flex>
											<Flex direction="column">
												<Text m={0} p={0} c="grey" size="xs">
													Load Weight
												</Text>
												<p
													style={{
														fontFamily: 'monospace',
														fontSize: 16,
														fontWeight: 600,
														margin: 0,
													}}
												>
													{formData.weight ? formData.weight / 1000 : 0}t
												</p>
											</Flex>
										</Flex>
									</Grid.Col>
									<Grid.Col span={6}>
										<Flex direction="column" gap="xs">
											<Flex direction="column">
												<Text m={0} p={0} c="grey" size="xs">
													Truck Registration
												</Text>
												<p
													style={{
														fontFamily: 'monospace',
														fontSize: 16,
														fontWeight: 600,
														margin: 0,
													}}
												>
													{formData.truckRegistration}
												</p>
											</Flex>
										</Flex>
									</Grid.Col>
								</Grid>
							</Flex>
						</Flex>
					</Grid.Col>
					<Grid.Col pt="xl" span={12}>
						<Checkbox
							color="green"
							checked={isConfirmed}
							onChange={(event) => setIsConfirmed(event.currentTarget.checked)}
							label="I agree that the material has been received and inputted correctly."
						/>
					</Grid.Col>
				</Grid>
			</Flex>
		</MobileContainer>
	);
};
